export default __webpack_public_path__ + "static/media/480_dummy2016-nagelstudio01-de.b3759c34.png";